import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { INITIATE_PAYPAL_TRANSACTION } from '../../operations/mutations/initiate-paypal-transaction.js';

const useInitiatePaypalTransaction = ({ cartId , checkoutType  })=>{
    const [initiatePaypalTransaction, { data , loading , error: error1  }] = useMutation(INITIATE_PAYPAL_TRANSACTION, {
        variables: {
            input: {
                cartId,
                checkoutType
            }
        },
        onError: (error)=>{
            console.error(error.message);
            toast.failed('checkout.payment.paypal.initiate.error');
        }
    });
    return [
        initiatePaypalTransaction,
        {
            data,
            loading,
            error: error1
        }
    ];
};

export { useInitiatePaypalTransaction };
//# sourceMappingURL=use-initiate-paypal-transaction.js.map
